<template>
  <!-- Loading overlay for unsubscribing -->
  <div v-if="isUnsubscribing" class="modal-overlay">
    <div class="loading-content">
      <div class="spinner"></div>
      <p>Processing unsubscribe...</p>
    </div>
  </div>

  <!-- Unsubscribe Modal -->
  <div v-if="showModal" class="modal-overlay" @click="$emit('close')">
    <div class="modal-content" @click.stop>
      <h3>Confirm Unsubscribe</h3>
      <p>Are you sure you want to unsubscribe?</p>
      <div class="warning-list">
        <p>This will:</p>
        <ul>
          <li>Remove all premium benefits immediately</li>
          <li>Result in the immediate loss of Premium-related data</li>
          <li>Process a prorated refund to your payment method</li>
        </ul>
      </div>
      <div class="modal-actions">
        <button @click="$emit('close')">Keep Subscription</button>
        <button class="error unsubscribe-btn" @click="$emit('confirm')">Unsubscribe</button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  showModal: {
    type: Boolean,
    default: false
  },
  isUnsubscribing: {
    type: Boolean,
    default: false
  }
})

defineEmits(['close', 'confirm'])
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

@media (max-width: 450px) {
  .modal-content {
    padding: 1.5rem;
    width: 95%;
    border-radius: 8px;
  }
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: var(--color-heading);
}

@media (max-width: 450px) {
  .modal-content h3 {
    font-size: 1.25rem;
  }
}

.warning-list {
  background: var(--color-background-mute);
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
  text-align: left;
}

@media (max-width: 450px) {
  .warning-list {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
}

.warning-list ul {
  margin: 0.5rem 0 0 0;
  padding-left: 1.5rem;
}

.warning-list li {
  margin: 0.5rem 0;
}

.modal-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

.unsubscribe-btn {
  background: none;
  border: none;
  color: var(--color-error);
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0 1rem;
  display: block;
  margin: 0 auto;
}

.loading-content {
  text-align: center;
  color: white;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>